<template>
    <Head title="OCP: User"/>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <navigation :user-id="userId"/>
        </template>


        <div class="md:p-6">

            <div v-if="user" class="grid grid-cols-1 md:grid-cols-3 p-4 gap-4 items-start">

                <form
                    method="post"
                    class="grid grid-cols-3 justify-between items-center bg-white rounded gap-4 p-4"
                    @change="changeForm=true"
                    @submit.prevent="userUpdate"
                >
                    <strong>ID</strong>
                    <span class="col-span-2">{{ user.id }}</span>
                    <strong>Email</strong>
                    <span class="col-span-2">{{ user.email }}</span>
                    <strong>Username</strong>
                    <span class="col-span-2">{{ user.username }}</span>
                    <strong>Lang</strong>
                    <span class="col-span-2">{{ user.lang }}</span>
                    <strong>Demo</strong>
                    <svg v-if="user.isDemo" xmlns="http://www.w3.org/2000/svg" class="col-span-2 fill-current h-6 w-6 text-green-400" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="col-span-2 fill-current h-6 w-6 text-red-400" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <strong>Allow exchange</strong>
                    <svg v-if="user.allowExchange" xmlns="http://www.w3.org/2000/svg" class="col-span-2 fill-current h-6 w-6 text-green-400" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="col-span-2 fill-current h-6 w-6 text-red-400" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <strong v-if="this.$page.props.auth.user.role !== 'aml'">UTM</strong>
                    <span v-if="this.$page.props.auth.user.role !== 'aml'" class="col-span-2">{{ user.utm }}</span>

                    <strong v-if="this.$page.props.auth.user.role !== 'aml'">Host</strong>
                    <v-select v-model="userForm.host" v-if="access('user', 'editable') || this.$page.props.auth.user.role !== 'aml'">
                        <option :value="host" v-for="host in hosts">{{ host }}</option>
                    </v-select>
                    <v-input v-model="userForm.host" v-if="access('user', 'editable') || this.$page.props.auth.user.role !== 'aml'"/>
                    <span class="col-span-2" v-if="!access('user', 'editable') && this.$page.props.auth.user.role !== 'aml'">{{ userForm.host }}</span>

                    <strong>Create (UTC)</strong>
                    <span class="col-span-2">{{ moment(user.createdAt).utc().format('L LTS') }}</span>
                    <strong>Update (UTC)</strong>
                    <span class="col-span-2">{{ moment(user.updatedAt).utc().format('L LTS') }}</span>
                    <strong>Confirm (UTC)</strong>
                    <span v-if="user.confirmedAt" class="col-span-2">
                        {{ moment(user.confirmedAt).utc().format('L LTS') }}
                    </span>
                    <v-button-link v-else-if="access('user', 'editable')"
                       class="col-span-2"
                       :href="route('user.confirm', this.userId)"
                    >
                        Подтвердить
                    </v-button-link>
                    <span v-else class="col-span-2"></span>

                    <v-button-link
                        class="col-span-2"
                        type="button"
                        color="yellow"
                        :href="route('user.reset-password', this.userId)"
                        v-if="access('user', 'reset_password')"
                    >Сбросить пароль</v-button-link>
                    <div class="col-span-2" v-else></div>

                    <v-button
                        color="blue"
                        :disabled="!changeForm"
                        v-if="access('user', 'editable')"
                    >Сохранить</v-button>
                </form>

                <div class="md:col-span-2 bg-white rounded p-4" v-if="$page.props.auth.permissions.user.sessions">
                    <div class="flex flex-row justify-between items-center">
                        <h2 class="text-lg pb-2">Сессии <strong v-if="userSessions.count">({{ userSessions.count }})</strong></h2>

                        <v-button-link v-if="user.loginBlock" color="green" :href="route('user.unlock', this.userId)"  method="get" as="button">Разблокировать</v-button-link>
                        <v-button-link v-else color="red" :href="route('user.lock', this.userId)"  method="get" as="button">Заблокировать</v-button-link>
                    </div>
                    <div class="flex flex-col border-b  gap-2 p-2" v-for="ses in userSessions.rows">
                        <div class="grid grid-cols-2">
                            <v-label>IP</v-label>
                            <v-label>Session Key</v-label>
                            <strong>{{ ses.connectingIp }}</strong>
                            <span>{{ ses.sessionKey }}</span>
                        </div>
                        <div v-if="ses.message">
                            <v-label>Message</v-label>
                            <p>{{ ses.message }}</p>
                        </div>
                        <div>
                            <v-label>User Agent</v-label>
                            <p class="text-sm">{{ ses.userAgent }}</p>
                        </div>
                        <div class="grid grid-cols-4">
                            <v-label>Истекает</v-label>
                            <v-label>Создана</v-label>
                            <v-label>Обновлена</v-label>
                            <v-label>Закрыта</v-label>
                            <span>{{ moment(ses.expiresAt).utc().format('L LTS') }}</span>
                            <span>{{ moment(ses.createdAt).utc().format('L LTS') }}</span>
                            <span>{{ moment(ses.updatedAt).utc().format('L LTS') }}</span>
                            <span>{{ ses.closedAt ? moment(ses.closedAt).utc().format('L LTS') : '' }}</span>
                        </div>
                        <div class="flex  flex-row justify-end">
                            <v-button @click="logout({sessionId:ses.id, sessionKey:ses.sessionKey})" color="yellow">Разлогинить</v-button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VInput from "@/Components/Input";
import VSelect from "@/Components/Select";
import VButton from "@/Components/Button";
import VButtonLink from "@/Components/ButtonLink";
import VLabel from "@/Components/Label";
import moment from "moment";
import ButtonSecondary from "@/Components/ButtonSecondary.vue";

export default {
    components: {
        ButtonSecondary,
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VSelect,
        VButton,
        VButtonLink,
        VLabel,
    },
    props: {
        notifications: Array,
        hosts: Array,
        user: Object,
        userId: String,
    },
    data () {
        return {
            changeForm: false,
            referralEmail: '',
            userSessions:  {},
            userForm: useForm(this.user),
        }
    },
    mounted() {
        if(this.access('user', 'sessions'))
            axios.post(this.route('user.sessions'), {
                userId: this.userId,
            }).then(res => {
                const {data} = res;
                if(data.success)
                    this.userSessions = data.result;
            })
    },
    methods: {
        moment,
        userUpdate() {
            this.changeForm = false;
            this.userForm.post(this.route('user.update', this.userId))
        },
        sessionLock() {
            this.notifications.push({
                type: 'success',
                title: 'Waiting...'
            })
            useForm({}).get(this.route('user.unlock', this.userId))
        },
        sessionUnlock() {
            this.notifications.push({
                type: 'success',
                title: 'Waiting...'
            })
            useForm({}).get(this.route('user.lock', this.userId))
        },
        logout(data) {
            this.notifications.push({
                type: 'success',
                title: 'Waiting...'
            })
            useForm(data).post(this.route('user.sessions.logout', this.userId))
        },
    },
}
</script>
